import { IDeletePesquisaSatisfacaoClienteUseCase } from "../../../presentation/useCases/delete/delete_pesquisa_satisfacao_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeletePesquisaSatisfacaoClienteUseCase
 */

export class DeletePesquisaSatisfacaoClienteUseCase implements IDeletePesquisaSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deletePesquisaSatisfacaoCliente(
    idPesquisaSatisfacaoCliente: number,
  ): Promise<void> {
    await this.repository.deletePesquisaSatisfacaoCliente(idPesquisaSatisfacaoCliente);
  }
}
